import Banner from "../components/Banner";
import Layout from '../components/Layout';
import { Link } from "react-router-dom";
import CertikBadge from "../components/CertikBadge";
import PriceFlash from "../components/PriceFlash";


const Home = () => {

  return ( 
    <>
      <Layout>
      <Banner />
      {/* <PriceFlash /> */}
      <div className='block-row bg-success section-two'>
        <div className="container">
          <div className="title-row">
            <h2>Choose Your RZTO Purchase Path</h2>
          </div>

          <div className="section-two-main">
            <div className="flex section-two-main-div">
              <div className="w-100">
                <div className="s-two-content">
                  <div>
                    <h3>BUY RZTO INSTANTLY</h3>
                    <span>(No Signup)</span>
                  </div>
                  <div style={{ position: 'relative', alignSelf: 'end' }}>
                    <img className="s-section-img f-img" src="/images/token-1.svg" alt="" />
                    <img className="bg-star-img" src="/images/star-blue.svg" alt="star icon" />
                  </div>
                </div>
                <ul className="s-section-ul">
                  <li className="flex">
                    <img src="/images/star-blue.svg" alt="star icon" />
                    <span>Connect your wallet</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-blue.svg" alt="star icon" />
                    <span>Purchase tokens directly</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-blue.svg" alt="star icon" />
                    <span>Receive RZTO in 15 minutes</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-blue.svg" alt="star icon" />
                    <span>No signup required</span>
                  </li>
                </ul>
                <div className="s-section-bottom">
                  <p><span>Perfect for:</span> Investors who want quick token access</p>
                  <div className="btn-group">
                    <Link
                     to="/token/quick-buy"
                    className="btn btn-shadow token-data btn-lg"
                  >
                  QUICK PURCHASE</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex section-two-main-div">
              <div className="w-100">
                <div className="s-two-content">
                  <div>
                    <h3>BUY RZTO & GET FULL BENEFITS</h3>
                    <span>(Sign up + Buy)</span>
                  </div>
                  <div style={{ position: 'relative', alignSelf: 'end' }}>
                    <img className="s-section-img" src="/images/token-4.svg" alt="" />
                    <img className="bg-star-img" src="/images/star-pink.svg" alt="star icon" />
                  </div>
                </div>
                <ul className="s-section-ul">
                  <li className="flex">
                    <img src="/images/star-pink.svg" alt="star icon" />
                    <span>Purchase tokens</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-pink.svg" alt="star icon" />
                    <span>Register for RZTO ecosystem</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-pink.svg" alt="star icon" />
                    <span>Unlock zoyili.com travel discounts</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-pink.svg" alt="star icon" />
                    <span>Access fitness & lifestyle vouchers</span>
                  </li>
                  <li className="flex">
                    <img src="/images/star-pink.svg" alt="star icon" />
                    <span>Get exclusive community perks</span>
                  </li>
                </ul>
                <div className="s-section-bottom">
                  <p><span className="s-section-span-pink">Perfect for:</span> Users who want to use RZTO utility features</p>
                  <div className="btn-group">
                    <Link to='/token/rzto' className="btn btn-shadow token-data btn-lg">BUY + REGISTER - $0.004</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p className="s-two-bottom-p">
            <span>Same price, same tokens, same delivery speed.</span>
            <span>All purchases are secure and tokens are delivered instantly</span>
          </p>
        </div>
      </div>

      {/* Subscribe Section */}
      <div className="block-row  bg-brand-1 subscribe-block">
        <div className="container">

          <div className="subscribe-caption">
            <div className="wow animate__animated animate__fadeInLeft">
              <div className="title-row">
                <h3>Backed by Industry Leaders & Real Partnerships</h3>
              </div>
              <figure>
                <img className="img" src="/images/partnerships.svg" alt="" />
              </figure>
            </div>

            <div className="caption-right">
              <p>Recent Achievements & Partnerships:</p>
              <ul>
                {/* <li className="flex">
                  <img src="/images/star-white.svg" alt="star icon" />
                  <span>Harveer Singh awarded by American Bankers Association for AI & Analytics Innovation</span>
                </li> */}
                <li className="flex">
                  <img src="/images/star-white.svg" alt="star icon" />
                  <span>Active partnership campaign with Amazon & Amdocs</span>
                </li>
                <li className="flex">
                  <img src="/images/star-white.svg" alt="star icon" />
                  <span>Featured in major crypto media: Crypto Daily, Bitcoin Ethereum News, BTCC</span>
                </li>
                <li className="flex">
                  <img src="/images/star-white.svg" alt="star icon" />
                  <span>FCC-licensed telecom partner: Rizz Wireless (official US mobile operator)</span>
                </li>
                <li className="flex">
                  <img src="/images/star-white.svg" alt="star icon" />
                  <span>Certik security audit completed</span>
                </li>
              </ul>
              <div className="buble-sec">
                <div className="left-buble">
                  <div className="green-buble">
                    <a
                    style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    cursor: 'pointer'
                    }} 
                   href="https://cryptodaily.co.uk/2025/05/rzto-token-set-to-push-the-boundaries-of-telecom-with-web3-integration" target="_blank" rel="noopener noreferrer" >"RZTO Token Set to Push Boundaries of Telecom" </a></div>
                  <p>Crypto Daily</p>
                </div>
                <div className="right-buble">
                  <div className="green-buble blue-buble" >
                    <a  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    cursor: 'pointer'
                    }} 
                  href="https://bitcoinworld.co.in/8-crypto-tokens-for-passive-income-in-2025/" target="_blank" rel="noopener noreferrer">"Real-World Utility Meets Blockchain Innovation"</a></div>
                  <p>Bitcoin Ethereum News</p>
                </div>
                <div className="left-buble last-bbl">
                  <div className="green-buble">
                    <a  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    cursor: 'pointer'
                    }} 
                     href="https://coinmarketcap.com/community/articles/683507662389d556617635c0/" target="_blank" rel="noopener noreferrer">
                    "First Legit Telecom Crypto with FCC Partnership" </a></div>
                  <p>BTCC</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How Its Work Section */}
      <div className="block-row bg-warn pt-2x bg-eye how-work-main" id="how-it-works">
        <div className="container">
          <div className="title-row how-work">
            <h3>See How Your RZTO Tokens Work in Real Life</h3>
          </div>
          <div className="flex tech-area">
            <div className="item-box wow animate__animated animate__fadeIn ">
              <div className="img-box bg-brand-1">
                <figure>
                  <img src="/images/tech-1.svg" alt="" />
                </figure>
              </div>
              <div className="caption-area">
                <h5>Travel Smart With RZTO</h5>
                <div className="how-it-works">
                  <span>How it works:</span>
                  <p>RZTO Tokens → Zoyili.com Voucher → Book Hotels & Flights → Save 30-50%</p>
                </div>
                <p>Use your earned RZTO to get travel vouchers, then book discounted hotels and flights through our zoyili.com partnership.</p>
              </div>
            </div>
            <div className="item-box wow animate__animated animate__fadeInUp">
              <div className="img-box bg-brand">
                <figure>
                  <img src="/images/tech-2.svg" alt="" />
                </figure>
              </div>
              <div className="caption-area">
                <h5>Fitness & Lifestyle</h5>
                <div className="how-it-works">
                  <span>How it works:</span>
                  <p>RZTO Tokens → Gift Card → Shop & Save at Top Brands</p>
                </div>
                <p>Partners include: Nike, Adidas, Lifetime Fitness, McDonald's and growing list of lifestyle brands. Turn your mobile usage into real savings.</p>
              </div>
            </div>
            <div className="item-box wow animate__animated animate__fadeIn">
              <div className="img-box bg-success">
                <figure>
                  <img src="/images/tech-3.svg" alt="" />
                </figure>
              </div>
              <div className="caption-area">
                <h5>Earn While You Connect</h5>
                <div className="how-it-works">
                  <span>The earning cycle:</span>
                  <p>Use Rizz Wireless → Earn RZTO → Stake for Data → Repeat</p>
                </div>
                <p>Rizz Wireless subscribers automatically earn: • 100 RZTO per plan renewal • 1 RZTO per call minute • 5 RZTO per unused GB of data</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why RZTO Gets More Valuable Over Time */}
      <div className="block-row pt-2x bg-brand why-valuable" id="why-rizznet">
        <div className="container">
          <div className="title-row">
            <h3>Why RZTO Gets More Valuable Over Time</h3>
          </div>
          <div className="why-valuable-main">
            <div className="valuable-caption">
              <img className="valuable-img" src="/images/why-Valuable-1.svg" alt="" />
              <p>Every real transaction burns RZTO tokens forever:</p>
              <ul className="valuable-ul">
                <li className="flex">
                  <img src="/images/star-pink.svg" alt="star icon" />
                  <span>Mobile plan payments: portion burned</span>
                </li>
                <li className="flex">
                  <img src="/images/star-pink.svg" alt="star icon" />
                  <span>Zoyili.com bookings: portion burned</span>
                </li>
                <li className="flex">
                  <img src="/images/star-pink.svg" alt="star icon" />
                  <span>Brand voucher purchases: portion burned</span>
                </li>
                <li className="flex">
                  <img src="/images/star-pink.svg" alt="star icon" />
                  <span>Staking rewards: portion burned</span>
                </li>
              </ul>
              <span>Result: Continuous supply reduction as usage grows</span>
            </div>

            <div className="valuable-caption">
              <img className="valuable-img" src="/images/why-Valuable-2.svg" alt="" />
              <p></p>
              <ul className="valuable-ul">
                <li className="flex">
                  <img src="/images/star-green.svg" alt="star icon" />
                  <span>Stake your RZTO tokens</span>
                </li>
                <li className="flex">
                  <img src="/images/star-green.svg" alt="star icon" />
                  <span>Earn 8-10% APY paid in mobile data</span>
                </li>
                <li className="flex">
                  <img src="/images/star-green.svg" alt="star icon" />
                  <span>Data can be used or traded</span>
                </li>
                <li className="flex">
                  <img src="/images/star-green.svg" alt="star icon" />
                  <span>Inspired by Bitcoin's proven model</span>
                </li>
              </ul>
              <span>The more people use RZTO services, the more valuable remaining tokens become.</span>
            </div>

            <div className="valuable-caption">
              <img className="valuable-img" src="/images/why-Valuable-3.svg" alt="" />
              <p></p>
              <ul className="valuable-ul">
                <li className="flex">
                  <img src="/images/star-yellow.svg" alt="star icon" />
                  <span>Rizz Wireless user expansion across USA</span>
                </li>
                <li className="flex">
                  <img src="/images/star-yellow.svg" alt="star icon" />
                  <span>Zoyili.com integration in international markets</span>
                </li>
                <li className="flex">
                  <img src="/images/star-yellow.svg" alt="star icon" />
                  <span>Growing brand partnership network</span>
                </li>
                <li className="flex">
                  <img src="/images/star-yellow.svg" alt="star icon" />
                  <span>Major exchange listings planned</span>
                </li>
              </ul>
              <span>The more people use RZTO services, the more valuable remaining tokens become.</span>
            </div>
          </div>
        </div>
      </div >

      {/* Team Section */}
      <div className="block-row bg-success pt-2x reduction-block">
        <div className="container">
          <div className="img-part">
            <figure>
              <img src="/images/supply.svg" alt="" />
            </figure>
          </div>
          <div className="title-row">
            <h3>Built by Proven Team, Secured by Experts</h3>
          </div>
          <div className="flex" style={{ maxWidth: '100%' }}>
            <div className="content-area" style={{ maxWidth: '100%' }}>
              <div className="flex reduction-area">
                <div className="item-box reduction-area-box animate__flipInY wow animate__animated animate__delay-1s">
                  <figure>
                    <img src="/images/Ganpatsingh-Rajput-image.svg" alt="" />
                  </figure>
                  <div className="caption-area">
                  <Link to="https://www.linkedin.com/in/grajput" target="_blank" rel="noopener noreferrer">
                    <h5>
                    Ganpatsingh Rajput
                    </h5>
                  </Link> 
                    <span>FOUNDER & CEO</span>
                    <p>15+ years telecom experience, successful tech entrepreneur</p>
                  </div>
                </div>
                <div className="item-box reduction-area-box animate__flipInY wow animate__animated animate__delay-1s">
                  <figure>
                    <img src="/images/Harveer-Singh-image.svg" alt="" />
                  </figure>
                  <div className="caption-area">
                     <Link to="https://www.linkedin.com/in/harveer" target="_blank" rel="noopener noreferrer">
                     <h5>Harveer Singh</h5>
                  </Link>                   
                    <span>FOUNDER & CIO</span>
                    <p>Recent American Bankers Association award winner</p>
                  </div>
                </div>
                <div className="item-box reduction-area-box animate__flipInY wow animate__animated animate__delay-1s">
                  <figure>
                    <img src="/images/Ranjith-Rajasekharan-image.svg" alt="" />
                  </figure>
                  <div className="caption-area">
                      <Link to="https://www.linkedin.com/in/rrajasekharan" target="_blank" rel="noopener noreferrer">
                    <h5>Ranjith Rajasekharan</h5>
                  </Link>   
                    <span>CHIEF MARKETING OFFICER</span>
                    <p>Former MTV, Pepsi marketing executive with proven track record</p>
                  </div>
                </div>
                <div className="item-box reduction-area-box animate__flipInY wow animate__animated animate__delay-1s">
                  <figure>
                    <img src="/images/Michael.svg" alt="" />
                  </figure>
                  <div className="caption-area">
                      <Link to="https://www.linkedin.com/in/mike-hiatt-2155a419" target="_blank" rel="noopener noreferrer">
                    <h5>Michael Hiatt</h5>
                  </Link> 
                    <span>TELECOM PARTNERSHIP ADVISOR</span>
                    <p>Dynamic professional with multinational telecom infrastructure experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Choose Your Path Section */}
      <div className="block-row pt-2x bg-brand chose-path">
        <div className="container">
          <div className="title-row">
            <h3>Ready to Own RZTO? Choose Your Path</h3>
          </div>
          <div className="right-corner-border"></div>
          <div className="right-banner">
            <h5>Start earning from your phone today!</h5>
          </div>
          <p>RZTO isn't just another crypto token - it's your key to earning from everyday mobile usage while getting access to exclusive discounts and lifestyle perks.</p>
          <div className="price-div">
            <p>Current Price:  <span>$0.004</span></p>
            <p>No Minimum Purchase</p>
            <div className="flex price-div-btns">
              <div className="btn-group white-bg-btn">
                  <Link to='/token/quick-buy'
                    className="btn btn-shadow token-data btn-lg"
                  >
                  QUICK PURCHASE</Link>
              </div>
              <div className="btn-group">
                <Link to='/token/rzto' className="btn btn-shadow token-data btn-lg">BUY + REGISTER - $0.004</Link>
              </div>
            </div>
          </div>
          <ul className="chose-path-ul">
            <li className="flex">
              <img src="/images/star-black-pink-bg.svg" alt="star icon" />
              <span>Secure payments via blockchain</span>
            </li>
            <li className="flex">
              <img src="/images/star-black-yellow-bg.svg" alt="star icon" />
              <span>Tokens delivered within 15 minutes</span>
            </li>
           <li className="flex" style={{alignItems: "center"}}>
          <img src="/images/star-black-purple-bg.svg" alt="star icon" />
             
          <span style={{display: "flex", alignItems: "center"}}>
          Contract audited by
            <a 
              href="https://skynet.certik.com/projects/rzto" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{display: "flex", alignItems: "center", marginLeft: "4px"}}
            >
            
              <img 
                src="/images/certik.png" 
                alt="Certik audit badge" 
                style={{height: "20px", marginLeft: "5px"}}
              />
            </a>
          </span>
        </li>
          </ul>
          <div className="bottom-text">
            <p>Remember:</p>
            <p>Same tokens, same price, same security - just choose the experience that fits your needs.</p>
          </div>
          <CertikBadge/>
          <img className="flying-man" src="/images/flying-man.svg" alt="" />
        </div>
      </div>
      </Layout>
    </>
  );
};

export default Home;
